export default {
  NEW_CAMERA_DIALOG(state, value) {
    state.newCameraDialog = value;
  },
  REQUEST_ROOM_CAMERA(state) {
    state.status = "fetching";
  },
  SUCCESS_REQUEST_ROOM_CAMERA(state, { roomcameras }) {
    state.status = "success";
    state.items = roomcameras;
  },
  FAILURE_REQUEST_ROOM_CAMERA(state) {
    state.status = "failure";
  },
};
